import { IFormConfigSectionQualifier } from "../../model/formconfiguration/FormConfigSectionQualifier";
import { IFormSectionService } from "../../service/formconfiguration/FormSectionService";

export default class CreateFormConfigSectionQualifierInteractor {
  private formSectionService: IFormSectionService;

  constructor(formSectionService) {
    this.formSectionService = formSectionService;
  }

  async execute(
    formTypecode: string,
    formSectionId: number,
    createFormConfigSectionQualifier: IFormConfigSectionQualifier
  ) {
    await this.formSectionService.createFormConfigSectionQualifier(
      formTypecode,
      formSectionId,
      createFormConfigSectionQualifier
    );
  }
}
